import "./Footer.css";
import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuthContext } from "../firebase/AuthContext";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userLanguage } = useAuthContext();

  const texts = {
    de: {
      imprint: "Impressum",
      tc: "AGB",
      privacyPolicy: "Datenschutzerklärung",
      contact: "Kontaktiere uns",
    },
    en: {
      imprint: "Legal Notice",
      tc: "Terms & Conditions",
      privacyPolicy: "Privacy Policy",
      contact: "Contact Us",
    },
  };

  return (
    <>
      <div className="footer">
        <Link className="nav-icon" to={"/imprint"}>
          {texts[userLanguage]["imprint"]}
        </Link>
        <Link className="nav-icon" to={"/termsConditions"}>
          {texts[userLanguage]["tc"]}
        </Link>
        <Link className="nav-icon" to={"/privacyPolicy"}>
          {texts[userLanguage]["privacyPolicy"]}
        </Link>
        <Link className="nav-icon" to={"/contact"}>
          {texts[userLanguage]["contact"]}
        </Link>
      </div>
    </>
  );
}

export default Footer;
